import React from 'react'

const Behaviour = () => {
  return (
    <>
           <div className="dr-header">
        <div className="header-contant">
          <h1> Services</h1>
          <p>Doctor {" > "} Behavioural Disorders</p>
        </div>
      </div>

      <div className="diabp">
        <h1>Behavioural Disorders</h1>
        <div className="bp-row">
          <div className="bp-col">
            <p>
            At our clinic, we have child psychiatrists who accept referrals for a thorough assessment and following specific recommendations children are assessed by clinical psychologists who are trained ABA therapy, Rolex GMT Master Replica psychotherapy and cognitive behavioural therapy. They are enrolled onto a targeted program to help them and the family with these concerns.
            </p>
          </div>
          <div className="bp-col">
            <img src="./img/Conduct-disorders.jpg" alt="" />
          </div>
        </div>
      </div>
    </>
  )
}

export default Behaviour
